document.addEventListener('DOMContentLoaded', () => {

    class beforeAfter extends HTMLElement {
        constructor () {
            super();

            this.slider = this.querySelector('.be-af-slider');
            this.before = this.querySelector('.be-af-before');

            this.state = false;

            if(!this.slider || !this.before) return;

            this.slider.addEventListener('mousedown', () => this.updateState(true))
            this.slider.addEventListener('touchstart', () => this.updateState(true))

            document.addEventListener('mouseup', () => this.updateState(false))
            document.addEventListener('touchend', () => this.updateState(false))

            this.addEventListener('mousemove', (e) => this.listenDrag(e));
            this.addEventListener('touchmove', (e) => this.listenDrag(e.touches[0]));
        }

        updateState (state) {
            this.state = state;
            if(state == true) unsetActive(this);
        }

        listenDrag (e) {
            if(!this.state) return;
            let clientRect = this.getBoundingClientRect();
            let xPosition = (e.clientX - clientRect.left) / this.offsetWidth * 100;

            const inset = 8;

            xPosition = Math.max(inset, Math.min(100 - inset, xPosition));

            this.slider.style.left = `${xPosition}%`;
            this.before.style.width = `${xPosition}%`;
        }
    }
    customElements.define('be-af', beforeAfter);

}, { passive: true});